import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccordionComponent } from '../../../../../shared/components/accordion/accordion.component';
import { AccordionItemComponent } from '../../../../../shared/components/accordion/accordion-item.component';
import { LoadingComponent } from '../../../../../shared/components/loading/loading.component';
import { ProductSkuViewData } from '../../admin-product-view.model';

@Component({
  selector: 'app-sku-prices',
  standalone: true,
  imports: [CommonModule, AccordionComponent, AccordionItemComponent, LoadingComponent],
  templateUrl: './sku-prices.component.html',
})
export class SkuPricesComponent {
  /** NOTA: o parent muta skuPrices assincronamente após o primeiro render */
  @Input({ required: true }) sku!: ProductSkuViewData;
}
